import { createDomain } from 'effector';

export const domain = createDomain('@root');
